module.exports = __webpack_public_path__ + "static/media/hw_a_1.a12e3f7e.flv";